import { render, staticRenderFns } from "./BoardsV2IntroBanner.vue?vue&type=template&id=1f8dc498&scoped=true"
import script from "./BoardsV2IntroBanner.vue?vue&type=script&lang=ts"
export * from "./BoardsV2IntroBanner.vue?vue&type=script&lang=ts"
import style0 from "./BoardsV2IntroBanner.vue?vue&type=style&index=0&id=1f8dc498&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8dc498",
  null
  
)

export default component.exports